// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"378":"6e9d653d","568":"9d1e91df","731":"0b95729e","759":"2cea3b3e","900":"7393dccb","952":"0951e600"}[chunkId] + ".chunk.css";
};